import { DIContainer } from "Global/Base/DIContainer";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../Global/Base/Rights/RightTypes";
import { Control as BaseControl } from "../../../UI.BaseControls/Control";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Control } from "../Controls/Control";
import { IFRMParams } from "../Controls/FormParameters";
import { IFormUI } from "../FormUI/FormUI";
import { Form } from "../XGControls/Form";
import { IMasterableFrame } from "../XGControls/Frames/FrameInterfaces";
import { IForm, IUsingFormUI } from "../XGControls/IForm";
import { FormInternalPanel } from "../XGControls/Internal/FormInternalPanel";

/**
 * Programově vytvářený formulář
 */
export class ProgrammableForm extends Form implements IForm, IUsingFormUI {
    //#region Fields
    /** Pokud je nastaveno na true, tak formulářové menu nebude k dispozici */
    public override disableFormMenu: boolean = true;

    /** Název formuláře */
    public override set titleLocKey(val: string) {
        this.element.setAttribute("data-captionlockey", val);
    }

    /** Název formuláře */
    public override get titleLocKey(): string {
        return this.element.getAttribute("data-captionlockey");
    }
    //#endregion Fields

    /**
     *
     * @param formCode Unikátní kód formuláře. Potřeba v testech, které hledají form podle kódu
     * @param formInstanceId Identifikátor otevřené instance formuláře.
     * @param formParams Parametry formuláře
     */
    constructor(formCode: string, formInstanceId: string, formParams?: IFRMParams) {
        super({
            ownerForm: undefined,
            element: createElement({ attrs: { "data-name": formCode, "data-behaviour": "form", "data-allowresponsivelayout": "true", "data-width": "800", "data-height": "600" } }),
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
            formInstanceId,
            parametricData: formParams,
        });
        const formInternalPanel = new FormInternalPanel({
            element: createElement({ attrs: { "data-TSCControl": "FormInternalPanel" } }),
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
        });
        this._formInternalPanel = formInternalPanel.element;
        this.element.appendChild(this._formInternalPanel);
    }

    //#region Methods
    /**
     *Inicializuje formulář
     */
    public override async init(formUI?: IFormUI): Promise<void> {
        await super.init(formUI ? formUI : DIContainer.instance.create(IFormUI, this));
        this._menu.hideFormMenu = true;
    }

    /**
     * Přidá programově vytvořenou komponentu na form
     */
    public addControl(ctrl: Control | BaseControl | HTMLElement): void {
        if (ctrl instanceof IMasterableFrame) {
            ctrl.ownerForm = this;
        }

        let el: HTMLElement;
        if (ctrl instanceof Control)
            el = ctrl.element;
        else
            el = ctrl;

        if (this._formInternalPanel)
            this._formInternalPanel.appendChild(el);
        else
            this.element.appendChild(el);
    }
    //#endregion Methods
}
